import styled, { css } from 'styled-components';

export const TreeViewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const TreeView = styled.div<{ paddingLeft: number }>(
  ({ paddingLeft }) => css`
    padding-left: ${paddingLeft}px;
  `,
);
